<!--    
@author zhijie.huang
@date 2018/9/29
@version v1.1.0
@description hostList 主机列表
-->
<template>
  <div class="hostlist__content">
    <el-form ref="form" :model="form" :inline="true" input-width="auto">
      <el-form-item :label="$t('hostList.table.siteCode')">
        <g-select :list="hostList" v-model="form.site" :default-all="true"></g-select>
      </el-form-item>
      <el-form-item :label="$t('hostList.table.group')">
        <g-select :list="groupList" v-model="form.group" :default-all="true" @change="e_selectGroupChange"></g-select>
      </el-form-item>
      <el-form-item :label="$t('hostList.table.applications')">
        <g-select :list="appList" v-model="form.applications" :default-all="true"></g-select>
      </el-form-item>
      <el-form-item :label="$t('hostList.table.status')">
        <g-select :list="statusList" v-model="form.status" :default-all="true"></g-select>
      </el-form-item>
      <el-form-item>
        <el-input v-model="form.ip" prefix-icon="uk-icon-search" :placeholder="$t('hostList.ipFuzzyQuery')"></el-input>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="e_search">{{ $t('common.search') }}</el-button>
      </el-form-item>
    </el-form>

    <div style="margin-bottom: 16px;">
      <el-button type="primary" @click="e_add" v-text="$t('hostList.add')" v-g-rac="gRac('hostList_add')"></el-button>
      <!-- <el-button type="primary" @click="e_export" v-text="$t('hostList.export')" v-g-rac="gRac('hostList_export')"></el-button> -->
      <el-button type="primary" @click="e_awsSyncShow" v-text="$t('hostList.awsSync')" v-g-rac="gRac('hostList_sync')"></el-button>
    </div>

    <el-table-extend 
      :data="tData" 
      :head="tHead" 
      :currentChange="tCurrentChange" 
      :sizeChange="tSizeChange" 
      border>
      <template slot="control-column" slot-scope="{data}">
        <el-table-extend-control 
          :control="tableControl" 
          :data="data" 
          :label="$t('common.handle')">
        </el-table-extend-control>
      </template>
    </el-table-extend>

    <el-dialog :closeOnClickModal="false"
      :title="$t('hostList.awsSync')"
      :visible.sync="awsSyncDialogVisible"
      width="400px">

      <g-select :list="hostList" v-model="awsSyncSite" :default-all="false"></g-select>
    
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="e_awsSyncConfirm">{{ $t('hostList.startSync') }}</el-button>
        <el-button @click="awsSyncDialogVisible = false">{{ $t('common.close') }}</el-button>
      </span>
    </el-dialog>

    <dialog-form
      key="hostEdit"
      :title="dialogTitle" 
      :size="3" 
      :label-size="2" 
      :visible.sync="dialogFormShow" 
      :model="dialogModel"
      :input-data="dialogData"
      :rules="dialogFormRule"
      :cancel-fun="e_cancel"
      :confirm-fun="isAdd ? e_saveConfirm : e_updateConfirm">
    </dialog-form>

    <el-dialog :title="$t('hostList.detail')" :visible.sync="dialogDetailShow" width="800px" :closeOnClickModal="false">
      <el-form label-position="left" label-width="120px" ref="hostDetail"  >
        <el-row>
          <el-col :span="24"><div class="hostlist__detailTitle">{{$t('hostList.basic')}}</div></el-col>
          <el-col :span="12">
            <el-form-item :label="$t('hostList.table.hostName')">
              <div class="hostlist__detailContent" :title="hostDetail.basic.hostName">{{ hostDetail.basic.hostName }}</div>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="$t('hostList.operator')">
              <div class="hostlist__detailContent" :title="hostDetail.basic.operator">{{ hostDetail.basic.operator }}</div>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="$t('hostList.table.hostType')">
              <div class="hostlist__detailContent" :title="hostDetail.basic.hostType">{{ hostDetail.basic.hostType }}</div>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="$t('hostList.table.systemVersion')">
              <div class="hostlist__detailContent" :title="hostDetail.basic.sysVersion">{{ hostDetail.basic.sysVersion }}</div>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="$t('hostList.nics')">
              <div class="hostlist__detailContent" :title="hostDetail.basic.nics">{{ hostDetail.basic.nics }}</div>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="$t('hostList.table.availabilityZone')">
              <div class="hostlist__detailContent" :title="hostDetail.basic.availabilityZone">{{ hostDetail.basic.availabilityZone }}</div>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="$t('hostList.table.ip1')">
              <div class="hostlist__detailContent" :title="hostDetail.basic.ip1">{{ hostDetail.basic.ip1 }}</div>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="$t('hostList.table.instanceId')">
              <div class="hostlist__detailContent" :title="hostDetail.basic.instanceId">{{ hostDetail.basic.instanceId }}</div>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="$t('hostList.table.ip2')">
              <div class="hostlist__detailContent" :title="hostDetail.basic.ip2">{{ hostDetail.basic.ip2 }}</div>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="$t('hostList.table.status')">
              <div class="hostlist__detailContent" :title="hostDetail.basic.status">{{ hostDetail.basic.status }}</div>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="$t('hostList.table.diskSpace')">
              <div class="hostlist__detailContent" :title="hostDetail.basic.diskSpace"></div>{{ hostDetail.basic.diskSpace }}
            </el-form-item>
          </el-col>
        </el-row>
        <el-row  v-show="hostDetail.platform.length>0">
          <el-col :span="24"><div class="hostlist__detailTitle">{{ $t('hostList.platform') }}</div></el-col>
          <el-col :span="12" v-for="(item, index) in hostDetail.platform" :key="index" v-if="hostDetail.platform.length!==0">
            <el-form-item v-for="(v, i) in item" :label="i" :key="i">
              <div class="hostlist__detailContent" :title="v">{{ v }}</div>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row v-show="hostDetail.softwares.length>0">
          <el-col :span="24"><div class="hostlist__detailTitle">{{ $t('hostList.softwares') }}</div></el-col>
          <div v-for="(itemS, indexS) in hostDetail.softwares" :key="indexS">
            <el-col :span="24"><div class="hostlist__softwares">{{ itemS.group }}</div></el-col>
            <el-col :span="12" v-for="(itemA, indexA) in itemS.appName" :key="indexA" class="hostlist__softwares--mb">
              <div class="hostlist__detailContent" :title="itemA">{{ itemA }}</div>
            </el-col>
          </div>
        </el-row>
        <el-row v-show="hostDetail.remarks!==''">
          <el-col :span="24"><div class="hostlist__detailTitle">{{$t('hostList.remark')}}</div></el-col>
          <el-col :span="24">
            <div class="hostlist__detailContent" :title="hostDetail.remarks">{{ hostDetail.remarks }}</div>
          </el-col>
        </el-row>
      </el-form>
    </el-dialog> 
  </div>
</template>

<script>
import rac from '@/plugins/rac-mixin'
import dic from '@/components/mixins/dic'
import table from '@/components/mixins/table'
import exportTips from '@/components/mixins/exportTips'
import CmdbBiz from '@/logic/cmdb/cmdbBiz'
import dialogForm from '@/components/dialogForm'
import dialogDetail from '@/components/dialogDetail'
import validateConfig from '@/utils/validate'
import { extend, getKeyByValue } from '@/utils/tool'
// import TimeFormat from '@/utils/timeFormat'

const DIC_MAP = {
  nicType: 'hostNetCard',
  environment: 'hostEnvironment',
  status: 'hostStatus',
  system: 'hostSystem',
  systemVersion: 'hostSystemVersion'
}

export default {
  mixins: [rac, dic, table, exportTips],
  data () {
    const that = this
    return {
      isAdd: true,
      dialogTitle: '',
      dialogFormShow: false,
      dialogDetailShow: false,
      dialogData: [],
      dialogDataForDetail: [],
      dialogModel: {
        id: '',
        hostName: '',
        hostType: '',
        nicType: '',
        ip1: '',
        ip2: '',
        environment: '',
        siteCode: '',
        system: '',
        systemVersion: '',
        tag: '',
        group: [],
        applications: [],
        contact: '',
        status: '',
        phone: '',
        remarks: ''
      },
      dialogModelAppTemp: [],
      dialogFormRule: {},
      form: {
        site: '',
        group: '',
        status: '',
        applications: '',
        ip: ''
      },
      groupList: {},
      hostDetail: {
        basic: {},
        platform: {},
        remarks: '',
        softwares: {}
      },
      hostList: {},
      statusList: {},
      appList: {},
      appForSelectBox: [],
      awsSyncSite: '',
      awsSyncAllSite: [],
      awsSyncDialogVisible: false,
      tableControl: [
        {
          label: that.$t('common.edit'),
          callback: that.e_update,
          rac: () => that.gRac('hostList_amend')
        }, {
          label: that.$t('common.check'),
          callback: that.e_detail,
          rac: () => that.gRac('hostList_detail')
        }, {
          label: that.$t('common.delete'),
          callback: that.e_delete,
          rac: () => that.gRac('hostList_delete')
        }
      ],
      doExport: null
    }
  },
  components: {
    dialogForm,
    dialogDetail
  },
  watch: {
    'form.site': function (val) {
      this.dGetGroup(val, true)
      this.groupList = this.$store.state.dicModule.group
      this.form.group = ''
      this.setDialogGroup(this.groupList)
    },
    'dialogModel.nicType': function (val) {
      this.setDialogIp(val)
    },
    'dialogModel.group': async function (val) {
      const arr = []
      let res = {}
      const pArr = []
      val.map((item) => {
        pArr.push(this.getAppByGroup(item).then((data) => {
          res = Object.assign(res, data)
        }))
      })
      await Promise.all(pArr)
      this.dialogModelAppTemp = []
      Object.keys(res).map((key) => {
        arr.push({
          key: key,
          label: res[key]
        })
        this.dialogModelAppTemp.push(key)
      })
      this.appForSelectBox = arr
    },
    'appForSelectBox': function (val) {
      this.setDialogApp(val)
    }
  },
  methods: {
    async preInitTable () {
      await Promise.all([
        CmdbBiz.siteNameList().then((data) => {
          this.hostList = data
        }),
        this.dGetGroup(),
        this.dGetDictionaryByCode('hostStatus'),
        this.dGetDictionaryByCode('hostSystem'),
        this.dGetDictionaryByCode('hostSystemVersion'),
        this.dGetDictionaryByCode('hostEnvironment'),
        this.dGetDictionaryByCode('hostNetCard'),
        CmdbBiz.getAppByGroup().then((data) => {
          this.appList = data
        })
      ])
      this.statusList = this.dDictionary.hostStatus
      this.groupList = this.$store.state.dicModule.group
      this.initTable()
      this.setDialogData()
      this.setDialogDataForDetail()
      this.setDialogGroup(this.groupList)
    },
    initTable () {
      this.tInitTable({
        lanKey: 'hostList.table',
        head: ['hostName', 'ip1', 'hostType', 'nicType', 'siteCode', 'department', 'environment', 'system', 'systemVersion', 'status'],
        requestFun: this.search,
        headOpt: {
          nicType: {
            formatter: 'Dictionary',
            formatterDic: this.dDictionary.hostNetCard
          },
          environment: {
            formatter: 'Dictionary',
            formatterDic: this.dDictionary.hostEnvironment
          },
          status: {
            formatter: 'Dictionary',
            formatterDic: this.dDictionary.hostStatus
          },
          system: {
            formatter: 'Dictionary',
            formatterDic: this.dDictionary.hostSystem
          },
          systemVersion: {
            formatter: 'Dictionary',
            formatterDic: this.dDictionary.hostSystemVersion
          },
          siteCode: {
            formatter: 'Dictionary',
            formatterDic: this.hostList
          }
        }
      })
    },
    search () {
      const reqData = extend(true, { ...this.tPageInfo }, this.form)
      CmdbBiz.hostList(reqData).then((data) => {
        this.tData = data
      }).catch((err) => {
        console.error(err)
      })
    },
    setDialogData () {
      this.dialogData = [
        {
          label: this.$t('hostList.table.hostName'),
          key: 'hostName',
          inputWidth: '200px'
        },
        {
          label: this.$t('hostList.table.hostType'),
          key: 'hostType',
          inputWidth: '200px'
        },
        {
          label: this.$t('hostList.table.nicType'),
          key: 'nicType',
          type: 'select',
          select: this.dDictionary.hostNetCard,
          inputWidth: '200px'
        },
        {
          label: this.$t('hostList.table.ip1'),
          key: 'ip1',
          inputWidth: '200px'
        },
        {
          label: this.$t('hostList.table.ip2'),
          key: 'ip2',
          inputWidth: '200px'
        },
        {
          label: this.$t('hostList.table.environment'),
          key: 'environment',
          type: 'select',
          select: this.dDictionary.hostEnvironment,
          inputWidth: '200px'
        },
        {
          label: this.$t('hostList.table.siteCode'),
          key: 'siteCode',
          type: 'select',
          select: this.hostList,
          inputWidth: '200px'
        },
        {
          label: this.$t('hostList.table.system'),
          key: 'system',
          type: 'select',
          select: this.dDictionary.hostSystem,
          inputWidth: '200px'
        },
        {
          label: this.$t('hostList.table.systemVersion'),
          key: 'systemVersion',
          type: 'select',
          select: this.dDictionary.hostSystemVersion,
          inputWidth: '200px'
        },
        {
          label: this.$t('hostList.table.group'),
          key: 'group',
          type: 'selectBox',
          selectBox: [],
          selectBoxChange: () => {}
        },
        {
          label: this.$t('hostList.table.applications'),
          key: 'applications',
          type: 'selectBox',
          selectBox: this.appForSelectBox,
          selectBoxChange: () => {}
        },
        {
          label: this.$t('hostList.table.contact'),
          key: 'contact',
          inputWidth: '200px'
        },
        {
          label: this.$t('hostList.table.phone'),
          key: 'phone',
          inputWidth: '200px'
        },
        {
          label: this.$t('hostList.table.status'),
          key: 'status',
          type: 'select',
          select: this.dDictionary.hostStatus,
          inputWidth: '200px'
        },
        {
          label: this.$t('hostList.table.remarks'),
          key: 'remarks',
          inputWidth: '200px'
        }
      ]
      this.dialogFormRule = {
        hostName: [{ ...validateConfig.common.notEmpty }],
        contact: [{ ...validateConfig.common.notEmpty }],
        phone: [{ ...validateConfig.common.isMobile }],
        ip1: [{ ...validateConfig.common.isIP }],
        ip2: [{ ...validateConfig.common.isIP }]
      }
    },
    setDialogApp (data) {
      this.$set(this.dialogData[10], 'selectBox', data)
      const arr = []
      this.dialogModel.applications.map((item) => {
        if (this.dialogModelAppTemp.find((app) => item === app)) {
          arr.push(item)
        }
      })
      this.dialogModel.applications = arr
    },
    setDialogGroup (group) {
      let arr = []
      Object.keys(group).map((key) => {
        arr.push({
          key: key,
          label: group[key]
        })
      })
      this.$set(this.dialogData[9], 'selectBox', arr)
    },
    setDialogIp (val) {
      if (Number(val) === 1) {
        this.$set(this.dialogData[4], 'hidden', false)
        this.$set(this.dialogFormRule, 'ip2', [{ ...validateConfig.common.isIP }])
      } else {
        this.$set(this.dialogData[4], 'hidden', true)
        this.$set(this.dialogFormRule, 'ip2', [])
        this.dialogModel.ip2 = ''
      }
    },
    setDialogDataForDetail () {
      const arr = [].concat(this.dialogData, [
        {
          label: this.$t('hostList.table.operator'),
          key: 'operator'
        },
        {
          label: this.$t('hostList.table.createTime'),
          key: 'createTime'
        },
        {
          label: this.$t('hostList.table.instanceType'),
          key: 'instanceType'
        },
        {
          label: this.$t('hostList.table.availabilityZone'),
          key: 'availabilityZone'
        },
        {
          label: this.$t('hostList.table.amiID'),
          key: 'amiID'
        },
        {
          label: this.$t('hostList.table.virtualization'),
          key: 'virtualization'
        },
        {
          label: this.$t('hostList.table.instanceId'),
          key: 'instanceId'
        },
        {
          label: this.$t('hostList.table.securityGroups'),
          key: 'securityGroups'
        },
        {
          label: this.$t('hostList.table.architecture'),
          key: 'architecture'
        },
        {
          label: this.$t('hostList.table.publicIpAddresses'),
          key: 'publicIpAddresses'
        },
        {
          label: this.$t('hostList.table.privateIpAddresses'),
          key: 'privateIpAddresses'
        }
      ])
      this.dialogDataForDetail = arr
    },
    getAppByGroup (group) {
      return CmdbBiz.getAppByGroup(group)
    },
    cleanDialogForm () {
      for (const key in this.dialogModel) {
        if (key === 'group' || key === 'applications') {
          this.dialogModel[key] = []
        } else {
          this.dialogModel[key] = ''
        }
      }
    },
    exportTable () {
      const that = this
      const list = Object.assign({}, that.$t('hostList.table'))
      delete list.id
      const dictionary = []
      for (const key in DIC_MAP) {
        dictionary.push({
          relate: key,
          type: that.dDictionary[DIC_MAP[key]]
        })
      }
      return function (search) {
        that.exRenderBefore()
        CmdbBiz.exportHostList(
          list,
          search,
          ['createTime'],
          dictionary,
          that.exRenderTips,
          that.exRenderFail
        )
      }
    },
    e_search () {
      this.tResetPage()
      this.search()
    },
    async e_selectGroupChange (data) {
      // console.info('e_selectGroupChange', data)
      const res = await this.getAppByGroup(data.key)
      this.appList = res || {}
    },
    e_awsSyncShow () {
      this.awsSyncSite = Object.keys(this.hostList)[0]
      if (this.awsSyncAllSite.length === 0) {
        CmdbBiz.allSite().then((data) => {
          this.awsSyncAllSite = data
          this.awsSyncDialogVisible = true
        })
      } else {
        this.awsSyncDialogVisible = true
      }
    },
    e_awsSyncConfirm () {
      const siteData = this.awsSyncSite
      const syncData = {}
      this.awsSyncAllSite.forEach((item) => {
        if (item.siteCode === siteData) {
          for (const i in item) {
            if (i !== 'operator') {
              syncData[i] = item[i]
            }
          }
        }
      })
      CmdbBiz.hostAwsAync(syncData).then((data) => {
        this.$message({
          message: this.$t('common.success'),
          type: 'success'
        })
        this.awsSyncDialogVisible = false
      })
    },
    e_export () {
      const search = extend({}, this.form)
      if (!this.doExport) this.doExport = this.exportTable()
      this.doExport(search)
    },
    e_update (row, index, data) {
      for (const key in this.dialogModel) {
        if ((key !== 'operator' || key !== 'createTime') && row[key]) {
          if (Object.keys(DIC_MAP).find((dickey) => dickey === key)) {
            this.dialogModel[key] = getKeyByValue(this.dDictionary[DIC_MAP[key]], row[key])
          } else {
            this.dialogModel[key] = row[key]
          }
        }
      }

      this.dialogTitle = this.$t('common.edit')
      this.dialogFormShow = true
      this.isAdd = false
    },
    e_detail (row, index, data) {
      this.dialogTitle = this.$t('common.check')
      CmdbBiz.getHostDetails({id: row.id}).then((res) => {
        this.hostDetail = {
          ...res
        }
        this.hostDetail.basic.sysVersion = this.dDictionary.hostSystemVersion[this.hostDetail.basic.sysVersion]
        this.hostDetail.basic.status = this.dDictionary.hostStatus[this.hostDetail.basic.status]
        this.hostDetail.basic.nics = this.hostDetail.basic.nics.join(',')
      })
      this.dialogDetailShow = true
    },
    e_delete (row, index, data) {
      this.$confirm(this.$t('common.deleteTips'), this.$t('common.tips'), {
        type: 'warning'
      }).then(() => {
        CmdbBiz.deleteHost({
          id: row.id
        }).then((data) => {
          this.$message({
            message: this.$t('common.success'),
            type: 'success'
          })
          this.search()
        })
      }).catch(() => {

      })
    },
    e_add () {
      this.cleanDialogForm()
      this.dialogTitle = this.$t('common.add')
      this.dialogFormShow = true
      this.isAdd = true
    },
    e_cancel () {
      this.cleanDialogForm()
    },
    e_updateConfirm (data) {
      CmdbBiz.updateHost(data).then((data) => {
        this.$message({
          message: this.$t('common.success'),
          type: 'success'
        })
        this.dialogFormShow = false
        this.cleanDialogForm()
        this.search()
      })
    },
    e_saveConfirm (data) {
      delete data.id
      CmdbBiz.addHost(data).then((data) => {
        this.$message({
          message: this.$t('common.success'),
          type: 'success'
        })
        this.dialogFormShow = false
        this.cleanDialogForm()
        this.search()
      })
    }
  },
  mounted () {
    this.preInitTable()
    this.search()
  }
}
</script>
<style scoped>
  .hostlist__detailTitle {
    border-bottom: 1px solid rgba(0, 0, 0, 0.09);
    font-size: 16px;
    font-weight: 600; 
    color: rgba(0, 0, 0, 0.85);
  }
  .hostlist__softwares {
    font-weight: 600; 
    line-height: 36px;
  }
  .hostlist__softwares--mb {
    margin-bottom: 16px;
  }
  .hostlist__detailContent {
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    cursor: pointer;
  }
</style>